module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/voucher-c2bb92d60142b7cb6fe0c3122483c178.png";